<ng-container [formGroup]="form.formGroup">
  <div
    [formArrayName]="form.formControlNames.sections"
    *ngFor="let sectionControl of form.formGroup.controls.sections.controls; let i = index">

    <app-frat-section-control [formControl]="sectionControl"></app-frat-section-control>

  </div>
</ng-container>
